// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"printLabel__msignaturepad___fhWs4","m-signature-pad--body":"printLabel__m-signature-pad--body___3LcHI","m-signature-pad--footer":"printLabel__m-signature-pad--footer___2wvqm","description":"printLabel__description___2CgEk","button":"printLabel__button___2mjNy","clear":"printLabel__clear___11Ebw","save":"printLabel__save___1y2WV","m-signature-pad":"printLabel__m-signature-pad___1Ze0w","github":"printLabel__github___DWakF","icon":"printLabel__icon___2Yvg4","anchor":"printLabel__anchor___3xEZP"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/printLabel.scss
// module id = Uqwq
// module chunks = client